import { render, staticRenderFns } from "./LineItemNotes.vue?vue&type=template&id=6bd00c5a&"
import script from "./LineItemNotes.vue?vue&type=script&lang=js&"
export * from "./LineItemNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports